import React, { Component } from "react";

const standardService = [
    {
        image: '01',
        title: 'Sviluppo e Integrazione Software',
        description: 'In Beatdata, ci dedichiamo alla realizzazione di software personalizzato per le vostre esigenze aziendali specifiche. Utilizzando tecnologie all\'avanguardia, creiamo applicazioni robuste e scalabili che aumentano l\'efficienza e la produttività del vostro business.',
    },
    {
        image: '03',
        title: 'Artificial Intelligence',
        description: 'L\'intelligenza artificiale sta trasformando il modo in cui le aziende operano. In Beatdata, offriamo servizi di sviluppo di soluzioni AI all\'avanguardia che consentono alle aziende di sfruttare appieno il potenziale della tecnologia.',
    },
    {
        image: '02',
        title: 'Blockchain',
        description: 'Realizziamo soluzioni personalizzate in ambito Blockchain, Smart Contract e Token. Curiamo lo sviluppo di Dapp e sistemi basati su Blockchain offrendo consulenza tecnica e strategica in questo settore',
    },
    {
        image: '05',
        title: 'Service Management',
        description: 'Siamo Matrix42 Competence Partner Silver. Grazie alla nostra competenza, con Matrix42 il vostro IT sarà in grado di gestire tutti i dispositivi, le applicazioni e i servizi in un\'unica soluzione',
    },
    {
        image: '06',
        title: 'DevOps',
        description: 'Forniamo la consulenza necessaria per applicare le metodologie DevOps ai processi di business, adottando approcci e strumenti che permettano di automatizzare le attività di controllo nei flussi di sviluppo',
    },
    {
        image: '04',
        title: 'Cloud & Data Center',
        description: 'Attraverso un’analisi della vostra infrastruttura forniamo le soluzioni adatte al vostro business utilizzando le migliori tecnologie a disposizione',
    },

]

class ServiceTwo extends Component{
    render(){
        let title = 'Services',
        description = 'Esplora le nostre competenze e scopri come possiamo aiutarti a spingere i confini della tua azienda nel mondo digitale in continua evoluzione.';
        return(
            <React.Fragment>
                <div className="row">
                    <div className="col-lg-4 col-12">
                        <div className="section-title mt--30 mt_md--5 mt_mobile--5 mb_mobile--10">
                            <h2 className="title">{title}</h2>
                            <p>{description}</p>
                        </div>
                    </div>
                    <div className="col-lg-8 col-12 mt_md--50">
                        <div className="row service-one-wrapper">
                            {standardService.map((value , index) => (
                                <div className="col-lg-4 col-md-4 mt--30" key={index}>
                                    <div className="standard-service">
                                        <div className="thumbnai">
                                            <img src={`/assets/images/featured/corporate-${value.image}.jpg`} alt="Corporate Images"/>
                                        </div>
                                        <div className="content">
                                            <h3><a href="/#">{value.title}</a></h3>
                                            <p>{value.description}</p>                                                    
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceTwo;
